<div class="flex flex-wrap relative w-full h-screen">
  <app-layers class="layers-menu" (layerToggled)="toggleLayer($event)"></app-layers>
  <h2 class="mb-4 text-2xl font-bold">Fiber and Handhole Map</h2>

  <!-- Google Map -->
  <google-map height="80vh" width="100%" #googleMap class="w-full h-full" [options]="options"
    mapId="a05906154fcbd7ce">
    <map-advanced-marker *ngFor="let deviceStatus of deviceStatuses$ | async" [position]="getPosition(deviceStatus)"
      [content]="getContent(deviceStatus)">
    </map-advanced-marker>
    <map-kml-layer [url]="kmlUrl" />
  </google-map>

  <!-- Control Buttons -->
  <div class="flex gap-4 mt-4">
    <button pButton label="Start Drawing" icon="pi pi-pencil" class="p-button-success"></button>
    <button pButton label="Save Drawing" icon="pi pi-save" class="p-button-primary"></button>
    <button pButton label="Cancel Drawing" icon="pi pi-times" class="p-button-danger"></button>
  </div>
</div>